// extracted by mini-css-extract-plugin
module.exports = {"instruction":"nmo-instr-btn_instruction__Y6XLm","question":"nmo-instr-btn_question__bP331","hint":"nmo-instr-btn_hint__h7Sdx","hintShown":"nmo-instr-btn_hintShown___MNAw"};